export enum FeeType {
    'OFFICE' = 'FEE_TYPES-OFFICE',
    'DEPARTMENT' = 'FEE_TYPES-DEPARTMENT',
    'REC_STATUS' = 'FEE_TYPES-REC_STATUS',
    'PROFILE_CHANGE_STATUS' = 'FEE_TYPES-PROFILE_CHANGE_STATUS',
    'EFFECTIVE_DATE' = 'EFFECTIVE_DATE',
    'FEE_TYPE_NAME' = 'FEE_TYPES-FEE_TYPE_NAME',
    'FEE_TYPE_DESCRIPTION' = 'FEE_TYPES-FEE_TYPE_DESCRIPTION',
    'PAYING_PARTY' = 'FEE_TYPES-PAYING_PARTY',
    'FEE_TYPE_GROUP' = 'FEE_TYPES-FEE_TYPE_GROUP',
    'REBATE' = 'FEE_TYPES-REBATE',
    'FEES_SUSP_ACC_NO' = 'FEE_TYPES-FEES_SUSP_ACC_NO',
    'FEES_SUSP_ACC_CCY' = 'FEE_TYPES-FEES_SUSP_ACC_CCY',
    'FEES_SUSP_ACC_OFFICE' = 'FEE_TYPES-FEES_SUSP_ACC_OFFICE',
    'TAX_RATE_APPLY_ON' = 'FEE_TYPES-TAX_RATE_APPLY_ON',
    'TAX_RATE' = 'FEE_TYPES-TAX_RATE',
    'TAX_RATE_VALID_UNTIL' = 'FEE_TYPES-TAX_RATE_VALID_UNTIL',
    'NEW_TAX_RATE' = 'FEE_TYPES-NEW_TAX_RATE',
    'TAX_ON_TAX_RATE' = 'FEE_TYPES-TAX_ON_TAX_RATE',
    'TAX_ON_TAX_RATE_VALID_UNTIL' = 'FEE_TYPES-TAX_ON_TAX_RATE_VALID_UNTIL',
    'NEW_TAX_ON_TAX_RATE' = 'FEE_TYPES-NEW_TAX_ON_TAX_RATE',
    'SEPARATE_TAX_ENTRY' = 'FEE_TYPES-SEPARATE_TAX_ENTRY',
    'TAX_SUSP_ACC_NO' = 'FEE_TYPES-TAX_SUSP_ACC_NO',
    'TAX_SUSP_ACC_CCY' = 'FEE_TYPES-TAX_SUSP_ACC_CCY',
    'TAX_SUSP_ACC_OFFICE' = 'FEE_TYPES-TAX_SUSP_ACC_OFFICE',
    'TIME_STAMP' = 'TIME_STAMP',
    'UID' = 'VIRTUAL-UID',
    'PROFILE_UPDATE_PK' = 'PROFILE_UPDATE_PK',
    'PU_TIME_STAMP' = 'PU_TIME_STAMP',
    'NOTE' = 'NOTE'
};
